import React from 'react';
import { Link } from 'react-router-dom';
import { Link2 } from 'lucide-react';

/** 広告を紐付けた商品が1つも無い組織。数字は商品単位でしか出さないので、紐付けに送る。 */
const TaapProductEmptyState: React.FC = () => (
  <div className="rounded-xl border border-gray-200 bg-white px-5 py-8 text-center text-sm">
    <Link to="/knowledge?tab=ad-accounts" className="inline-flex items-center gap-1.5 font-medium text-primary hover:underline">
      <Link2 className="h-4 w-4" />
      商品に広告アカウントを紐付ける
    </Link>
  </div>
);

export default TaapProductEmptyState;
